import React from "react";
import "./NewsEvents.css";
import EventCard from "../../components/eventcard/EventCard";
//import news from "../../assets/newsdat";
import news from "../../assets/news/newsdata";

function NewsEvents() {
  return (
    <>
      <section className="latest-news-section">
        <div className="container">
          <div className="section-header">
            <h2 className="sub-heading section-heading ">ข่าวสารล่าสุด</h2>
          </div>
          <div className="highlight-grid">
            <div className="highlight-text">
              <p>
                สมาคมนวัตกรรมสิ่งแวดล้อม (Environmental Innovation Association: EInA) จัดประชุมคณะกรรมการบริหารสมาคม ครั้งที่ 1/2568 ณ โรงแรมเดอะ แกรนด์ โฟร์วิงส์ คอนเวนชั่น กรุงเทพฯ
              </p>
            </div>
            <div className="highlight-image">
              <img src={news[0].image} alt={news[0].name} />
              <p className="hot-tag">HOT FOR TODAY</p>
              <h3 className="hot-title">{news[0].name}</h3>
            </div>
          </div>
        </div>
      </section>

      <section className="past-events-section">
        <div className="container">
          <div className="section-header">
            <h2 className="sub-heading section-heading ">
              ผลงานและกิจกรรมที่ผ่านมา
            </h2>
          </div>

          <div className="events-grid">
            {news.slice(0, 6).map((item, index) => (
              <EventCard
                key={index}
                id={item.id}
                image={item.image}
                name={item.name}
                data={item.data}
                context={item.context}
              />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default NewsEvents;
